import { Alert, UserPermissions } from '@centecomm/portal-service';
import { useAlerts, useCurrentUser } from '@centecomm/portal-service-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectors } from '../../State/Alerts';
import EmergencyAlert from './EmergencyAlert';

function EmergencyAlertDisplay(): React.ReactElement {
    const { hasPermission } = useCurrentUser();
    const { getAlerts } = useAlerts();

    const [alerts, setAlerts] = React.useState<Alert[]>([]);
    const [dismissed, setDismissed] = React.useState<number[]>([]);
    const [previousCount, setPreviousCount] = React.useState<number>(0);

    const alertsState: string[] = useSelector(selectors.alerts);

    const handleGetAlerts = async () => {
        try {
            const alertsResponse: Alert[] = await getAlerts();
            
            if (alertsResponse.length > 0) {
                setAlerts(
                    alertsResponse
                        .filter((alert: Alert) => !dismissed.includes(alert.alertId))
                        .filter((alert: Alert) => !alert.isExpired),
                );
            }
        } catch {
            // TODO: Log Error
        }
    };

    React.useEffect(() => {
        if (hasPermission(UserPermissions.ReceiveAlerts)) handleGetAlerts();
    }, []);

    React.useEffect(() => {
        if (alertsState.length > previousCount && hasPermission(UserPermissions.ReceiveAlerts)) {
            handleGetAlerts();

            setPreviousCount(alertsState.length);
        }
    }, [alertsState]);

    const handleDismissal = (id: number): void => {
        const alertIndex = alerts.findIndex((alert: Alert) => alert.alertId === id);

        if (alertIndex > -1) {
            setDismissed([...dismissed, alerts[alertIndex].alertId]);

            setAlerts([...alerts.slice(0, alertIndex), ...alerts.slice(alertIndex + 1)]);
        }
    };

    return (
        <>
            {alerts.map((alert) => (
                <EmergencyAlert key={`emergency-alerts-${alert.alertId}`} alert={alert} dismiss={handleDismissal} />
            ))}
        </>
    );
}

export default EmergencyAlertDisplay;
